// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9fc5b399","453":"8cbdeb80","732":"d5af8995","977":"35f47eb4"}[chunkId] + ".chunk.js";
};